import { inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useLanguageStore } from '@/stores/LanguageStore'
import { loadScript } from '@/utils/utils'

const gmapsSymbol = Symbol()

export const createGoogleMaps = {
  install: app => {
    const { getDocumentLanguage: language } = storeToRefs(useLanguageStore())

    const key = process.env.VUE_APP_GOOGLE_MAP_API_KEY

    const loadGoogleMaps = () => {
      const src = `https://maps.googleapis.com/maps/api/js?key=${key}&language=${language.value}&libraries=places`
      const script = document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]')

      if (script && script.getAttribute('src') !== src) {
        script.remove()
        delete window.google
      }

      return loadScript(src)
    }

    app.provide(gmapsSymbol, { loadGoogleMaps })
  }
}

export const useGoogleMaps = () => inject(gmapsSymbol)